import { Link } from "react-router-dom";
import { Youtube } from "lucide-react";
import { Wordmark } from "./Wordmark";
import { useSettings } from "../context/SettingsContext";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.6 3.6 3.7 3.9v2.6c-1.3.1-2.5-.3-3.7-1v6.9c0 4.3-3.7 7-7.1 5.8-2.9-1-4.1-4.4-2.6-7 .9-1.6 2.6-2.5 4.4-2.4v2.7c-.4-.1-.9-.1-1.3 0-1.5.4-2 1.9-1.3 3.1.7 1.2 2.6 1.2 3.2-.3.1-.4.2-.8.2-1.2V3h4.1z" />
  </svg>
);

export function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="on-navy bg-plexus-clear" data-testid="footer">
      <div className="container-brand grid gap-10 py-16 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Wordmark style={{ fontSize: 28 }} />
          <p className="mt-4 max-w-sm text-[15px] italic text-on-navy-body">"{settings.tagline}"</p>
          <p className="mt-1 font-sans text-[12px] font-bold uppercase tracking-[0.2em] text-on-navy-muted">
            {settings.support_line}
          </p>
          <div className="mt-6 flex gap-5">
            <a href={settings.youtube_url} target="_blank" rel="noreferrer" className="text-bone transition-colors hover:text-brick" aria-label="YouTube" data-testid="footer-youtube"><Youtube size={22} /></a>
            <a href={settings.tiktok_url} target="_blank" rel="noreferrer" className="text-bone transition-colors hover:text-teal-bright" aria-label="TikTok" data-testid="footer-tiktok"><TikTokIcon size={20} /></a>
          </div>
        </div>

        <div>
          <p className="eyebrow !text-ochre-bright">Explore</p>
          <ul className="mt-4 space-y-2 text-[15px]">
            {[["/setups", "Free Setups"], ["/nerd-scale", "The Nerd Scale"], ["/my-ai", "My AI"], ["/about", "About BJ"], ["/subscribe", "Get the setups"]].map(([to, label]) => (
              <li key={to}><Link to={to} className="text-on-navy-body no-underline transition-colors hover:text-bone">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow !text-ochre-bright">The fine print</p>
          <ul className="mt-4 space-y-2 text-[15px]">
            <li><Link to="/privacy" className="text-on-navy-body no-underline transition-colors hover:text-bone">Privacy</Link></li>
            <li><Link to="/terms" className="text-on-navy-body no-underline transition-colors hover:text-bone">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-brand flex flex-col gap-2 py-5 text-[12px] text-on-navy-muted sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Practical AI for Everyday Life · @everydayai_foryou</span>
          <span className="font-sans uppercase tracking-[0.16em]">practicalaiforeverydaylife.com</span>
        </div>
      </div>
    </footer>
  );
}
